export const updateMetaTag = (name: string, content: string) => {
  if (typeof document === 'undefined') return;
  const selector = `meta[name="${name}"]`;
  let tag = document.querySelector(selector) as HTMLMetaElement | null;
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
};

export const updateCanonicalLink = (href: string) => {
  if (typeof document === 'undefined') return;
  let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement('link');
    link.rel = 'canonical';
    document.head.appendChild(link);
  }
  link.href = href;
};

export const setStructuredData = (id: string, data?: Record<string, unknown>) => {
  if (typeof document === 'undefined') return;
  const existing = document.getElementById(id);
  if (existing) {
    existing.remove();
  }
  if (!data) {
    return;
  }
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.id = id;
  script.text = JSON.stringify(data);
  document.head.appendChild(script);
};
